import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ReplaySubject, of } from 'rxjs';
import { takeUntil, filter, catchError } from 'rxjs/operators';
import { UbiIdleService } from 'uber-ui';
import { AuthService } from './auth.service';
import * as AuthActions from 'store/actions/auth.actions';
import * as DomanActions from 'store/actions/domain.actions';
import { environment } from 'environment/environment';
import * as i0 from "@angular/core";
import * as i1 from "uber-ui";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/router";
import * as i4 from "./auth.service";
var IdleService = /** @class */ (function () {
    function IdleService(ubiIdleService, store, router, authService) {
        this.ubiIdleService = ubiIdleService;
        this.store = store;
        this.router = router;
        this.authService = authService;
        this.unsubscribe$ = new ReplaySubject(1);
    }
    /**
     * Dispatch logout when time out
     * @method onTimeout
     */
    IdleService.prototype.onTimeout = function () {
        this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: true }));
    };
    /**
     * Subscribe auth state in uber-ui
     * @method authStateSubscriber
     */
    IdleService.prototype.authStateSubscriber = function () {
        var _this = this;
        this.ubiIdleService.getAuthState()
            .pipe(takeUntil(this.unsubscribe$), filter(function (state) { return state !== null; }))
            .subscribe(function (state) {
            if (state === 'signedIn') {
                _this.router.navigateByUrl('dashboard');
            }
            else if (state === 'signedOut') {
                _this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: false }));
            }
        });
    };
    /**
     * Get current user to check auth state
     * @method getUser
     */
    IdleService.prototype.getUser = function () {
        var _this = this;
        this.authService.getUser(true)
            .pipe(takeUntil(this.unsubscribe$), catchError(function () {
            _this.authService.logOut().subscribe();
            _this.ubiIdleService.setBrowserLogout();
            _this.store.dispatch(new DomanActions.ClearLoadList());
            _this.store.dispatch(new AuthActions.ClearGetUser());
            return of(null);
        })).subscribe(function (user) {
            if (user) {
                _this.ubiIdleService.setBrowserLogin();
            }
        });
    };
    /**
     * Start idle service in uber-ui
     * @method start
     */
    IdleService.prototype.start = function () {
        var config = {
            sessionTimeout: environment['SESSION_TIMEOUT'] ? environment['SESSION_TIMEOUT'] : 1800000,
            onTimeout: this.onTimeout.bind(this)
        };
        this.ubiIdleService.init(config);
        this.authStateSubscriber();
        this.getUser();
    };
    /**
     * Stop & clear idle service in uber-ui
     * @method stop
     */
    IdleService.prototype.stop = function () {
        this.ubiIdleService.clear();
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    IdleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdleService_Factory() { return new IdleService(i0.ɵɵinject(i1.UbiIdleService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.AuthService)); }, token: IdleService, providedIn: "root" });
    return IdleService;
}());
export { IdleService };
